<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .recents-tab-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
    min-height: 0;
  }

  .recents-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .recents-empty {
    @include mixins.body3;
    text-align: center;
    color: colors.get(textGrey);
  }

  .dismiss-all-container {
    display: flex;
    justify-content: flex-end;
    position: sticky;
    top: 0;
    background-color: colors.get(interfaceWhite);
    z-index: 10;
  }

  .helper-text {
    display: flex;
    align-items: center;
    gap: 8px;
    @include mixins.body4;
    color: colors.get(textDisabledGrey);
    flex-shrink: 0;
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import { onDestroy, onMount } from "svelte";
  import { updateUploadsNotifications } from "../../../../../api/uploads-notifications";
  import { PROCESSED_STATUSES } from "../assets";
  import { uploadsNotificationsStore } from "../stores";
  import Notification from "./notifications/Notification.svelte";

  const notifications = $derived(
    $uploadsNotificationsStore?.notifications.sort((a, b) => {
      // Show new items first
      if (a?.viewed !== b?.viewed) {
        return a?.viewed ? 1 : -1;
      }

      return new Date(b.createdAt) - new Date(a.createdAt);
    })
  );

  const processedNotifications = $derived(
    notifications.filter((n) => PROCESSED_STATUSES.includes(n.status))
  );

  const handleDismissAll = async () => {
    const ids = processedNotifications.map((n) => n.notificationId);

    if (ids.length === 0) {
      return;
    }

    await updateUploadsNotifications({
      ids: ids,
      status: "deleted",
    });

    uploadsNotificationsStore.update((store) => ({
      notifications: store.notifications.filter(
        (n) => !ids.includes(n.notificationId)
      ),
    }));
  };

  const handleViewAll = async () => {
    const ids = processedNotifications
      .filter((n) => !n?.viewed)
      .map((n) => n.notificationId);

    if (ids.length === 0) {
      return;
    }

    await updateUploadsNotifications({
      ids: ids,
      viewed: true,
    });

    uploadsNotificationsStore.update((store) => ({
      notifications: store.notifications.map((n) =>
        ids.includes(n.notificationId) ? { ...n, viewed: true } : n
      ),
    }));
  };

  onMount(() => {
    uploadsNotificationsStore.once();
  });

  onDestroy(() => {
    handleViewAll();
  });
</script>

<div class="recents-tab-container">
  <div class="recents-content">
    {#if notifications.length === 0}
      <div class="recents-empty">Recent uploads will be displayed here</div>
    {:else}
      <div class="dismiss-all-container">
        <Button onclick={handleDismissAll} kind="ghost-grey" size="xsmall">
          Dismiss All
        </Button>
      </div>
      {#each notifications as upload}
        <Notification {upload} />
      {/each}
    {/if}
  </div>
  <div class="helper-text">
    <Icon class="fa-solid fa-circle-info" size="small" />
    <span
      >Resumes you upload will be processed in the background. You can come back
      later to review the results.</span
    >
  </div>
</div>
